import React from 'react';
import { Typography } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';
import UnpublishIllustration from '../atoms/UnpublishIllustration';
import { ContentColumn, Description } from '../styles';

const UnpublishConfirmBody: React.FC = () => {
  const { t } = useTranslation('components');

  return (
    <ContentColumn>
      <UnpublishIllustration />
      <Typography variant="h5" tone="primary">
        {t('unpublishRouteConfirmModal.leadIn')}
      </Typography>
      <Description>
        <Typography variant="body" tone="primary">
          {t('unpublishRouteConfirmModal.text')}
        </Typography>
        <Typography variant="body" tone="primary">
          {t('unpublishRouteConfirmModal.offlineDriverWarning')}
        </Typography>
        <Typography variant="body-strong" tone="primary">
          {t('unpublishRouteConfirmModal.confirmationPrompt')}
        </Typography>
      </Description>
    </ContentColumn>
  );
};

export default UnpublishConfirmBody;
